import { render, staticRenderFns } from "./lrCount.vue?vue&type=template&id=4f48fa96"
import script from "./lrCount.vue?vue&type=script&lang=js"
export * from "./lrCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports